import { useRouteMatch } from 'react-router';
import { useConversation } from './hooks/useConversation';
import { Tabs, Tab, Breadcrumbs, Loading } from '../../components';
import Conversation from './components/Conversation';

enum TabsEnum {
  ORIGIN = 'origin',
  ENGLISH = 'english',
}

type ConversationPageProps = {
  agentId: string;
  conversationId: string;
};

const ConversationPage = ({
  agentId,
  conversationId,
}: ConversationPageProps) => {
  const { params } = useRouteMatch<{ id: string }>();
  const {
    conversation,
    participant,
    messages,
    loadingMessages,
    audio,
    title,
    messagesEnglish,
    loadingMessagesEnglish,
    selfCostStatistics,
    loadingCostStatistics,
  } = useConversation(conversationId || params.id);

  const breadcrumbs = !agentId ? (
    <Breadcrumbs
      className="mb-md text-small"
      items={[
        { label: 'Conversations', url: '/conversation' },
        { label: conversation?.id || conversationId || 'Conversation' },
      ]}
    />
  ) : (
    <Breadcrumbs
      className="mb-md text-small"
      items={[
        { label: 'Agents', url: '/billing' },
        { label: title || 'Agent', url: `/billing/${agentId}` },
        { label: conversation?.id || conversationId || 'Conversation' },
      ]}
    />
  );

  return (
    <>
      {breadcrumbs}
      <Tabs<TabsEnum>
        tabs={[
          { name: TabsEnum.ORIGIN, label: 'Original' },
          { name: TabsEnum.ENGLISH, label: 'English' },
        ]}
        contentClassName="mt-md"
      >
        <Tab name={TabsEnum.ORIGIN}>
          <Conversation
            agentId={agentId}
            conversationId={conversationId}
            agentTitle={title || ''}
            conversation={conversation}
            participant={participant}
            messages={messages}
            audio={audio}
            loading={loadingMessages}
            selfCostStatistics={selfCostStatistics}
            loadingCostStatistics={loadingCostStatistics}
          />
        </Tab>
        <Tab name={TabsEnum.ENGLISH}>
          <div>
            <Conversation
              agentId={agentId}
              conversationId={conversationId}
              agentTitle={title || ''}
              conversation={conversation}
              participant={participant}
              messages={messagesEnglish}
              audio={audio}
              loading={loadingMessagesEnglish}
              selfCostStatistics={selfCostStatistics}
              loadingCostStatistics={loadingCostStatistics}
            />
          </div>
        </Tab>
      </Tabs>
    </>
  );
};

export default ConversationPage;
